import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const Phone01Icon = (props?: SvgProps) => (
  <svg
    width="24"
    height="24"
    fill="none"
    stroke="#19191B"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props?.title}</title>
    <path
      d="M9.99935 14.5846H10.0077M6.83268 18.3346H13.166C14.0994 18.3346 14.5661 18.3346 14.9227 18.153C15.2363 17.9932 15.4912 17.7382 15.651 17.4246C15.8327 17.0681 15.8327 16.6014 15.8327 15.668V4.33464C15.8327 3.40121 15.8327 2.9345 15.651 2.57798C15.4912 2.26438 15.2363 2.00941 14.9227 1.84962C14.5661 1.66797 14.0994 1.66797 13.166 1.66797H6.83268C5.89926 1.66797 5.43255 1.66797 5.07603 1.84962C4.76243 2.00941 4.50746 2.26438 4.34767 2.57798C4.16602 2.9345 4.16602 3.40121 4.16602 4.33464V15.668C4.16602 16.6014 4.16602 17.0681 4.34767 17.4246C4.50746 17.7382 4.76243 17.9932 5.07603 18.153C5.43255 18.3346 5.89926 18.3346 6.83268 18.3346ZM10.416 14.5846C10.416 14.8148 10.2295 15.0013 9.99935 15.0013C9.76923 15.0013 9.58268 14.8148 9.58268 14.5846C9.58268 14.3545 9.76923 14.168 9.99935 14.168C10.2295 14.168 10.416 14.3545 10.416 14.5846Z"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
)
